var map = {
	"./img-logo-cloud-aws.svg": 1484,
	"./img-logo-cloud-azure.svg": 1485,
	"./img-logo-cloud-google.svg": 1486,
	"./img-logo-codership.svg": 1487,
	"./img-logo-controller.svg": 1488,
	"./img-logo-elastic.svg": 1489,
	"./img-logo-haproxy.svg": 1490,
	"./img-logo-mariadb.svg": 1491,
	"./img-logo-mongodb.svg": 1492,
	"./img-logo-mssql.svg": 1493,
	"./img-logo-mysql.svg": 1494,
	"./img-logo-now.svg": 1495,
	"./img-logo-opsgenie.svg": 1496,
	"./img-logo-pagerduty.svg": 1497,
	"./img-logo-percona.svg": 1498,
	"./img-logo-pgvector.svg": 1499,
	"./img-logo-postgresql.svg": 1500,
	"./img-logo-prometheus.svg": 1501,
	"./img-logo-redis.svg": 1502,
	"./img-logo-slack.svg": 1503,
	"./img-logo-telegram.svg": 1504,
	"./img-logo-timescaledb.svg": 1505,
	"./img-logo-victoropts.svg": 1506,
	"./img-logo-webhooks.svg": 1507
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1483;